// Default State
const initialState = {
    individualID: JSON.parse(localStorage.getItem('individualID')) || '',
    isDataUnsent: false,
    encryptedIDs: JSON.parse(localStorage.getItem('encryptedIDs')) || '',
    prodTourID: JSON.parse(localStorage.getItem('prodTourID')) || '',
    token: JSON.parse(localStorage.getItem('token')) || ''
};

/**
 * Stores the prod tour and individual ID for the given user.
 */
const setUserIDs = (state, action) => {
    // Update local storage with the change to the user IDs
    localStorage.setItem(
        'individualID',
        JSON.stringify(action.ids.individualID)
    );
    localStorage.setItem(
        'prodTourID', 
        JSON.stringify(action.ids.prodTourID)
    );

    return {
        ...state,
        individualID: action.ids.individualID,
        prodTourID: action.ids.prodTourID
    };
};

/**
 * Stores the encrypted prod tour and individual ID for the current Backup Survey.
 */
const setEncryptedUserIDs = (state, action) => {
    // Update local storage with the change to the user IDs
    localStorage.setItem(
        'encryptedIDs',
        JSON.stringify(action.ids.encryptedIDs)
    );

    return {
        ...state,
        encryptedIDs: action.ids.encryptedIDs
    };
};

/**
 * Stores the encrypted token for the current Backup Survey.
 */
const setEncryptedToken = (state, action) => {
    // Update local storage with the token
    localStorage.setItem(
        'token',
        JSON.stringify(action.token)
    );

    return {
        ...state,
        token: action.token
    };
};

/**
 * Stores the prod tour and individual ID for the given user using survey payload data.
 */
const setUserIdsFromSurvey = (state, action) => {
    // Update local storage with the change to the user IDs

    localStorage.setItem(
        'individualID',
        JSON.stringify(action.data.Evaluator.IndividualId)
    );
    localStorage.setItem(
        'prodTourID', 
        JSON.stringify(action.data.Evaluator.ProdTourDetail.ProdTourId)
    );

    return {
        ...state,
        individualID: action.data.Evaluator.IndividualId,
        prodTourID: action.data.Evaluator.ProdTourDetail.ProdTourId
    };
};

/**
 * Updates the state to reflect if there are unsent answers.
 */
const setUnsentSubmissionStatus = (state, action) => {
    return {
        ...state,
        isDataUnsent: action.isUnsent
    };
};

const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USER_IDS':
            return setUserIDs(state, action);
        case 'SET_ENCRYPTED_USER_IDS':
            return setEncryptedUserIDs(state, action);
        case 'SET_ENCRYPTED_TOKEN':
            return setEncryptedToken(state, action);
        case 'GET_ENCRYPTED_DATA_RECEIVED':
            return setUserIdsFromSurvey(state, action);
        case 'SET_UNSENT_SUBMISSION_STATUS':
            return setUnsentSubmissionStatus(state, action);
        default:
            return state;
    }
};

export default dataReducer;



// WEBPACK FOOTER //
// ./application/reducers/dataReducer.js